// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  URL: 'https://api.meat2me.co.il/backend/api/index.php',
  fileUrl: 'https://api.meat2me.co.il/backend/api/download_file.php',
  token: 'af9e4dc4598f6beb817d4821a5bf6356cc0ce2ba9773fcec67a8f68c570fd682',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
